// AgencyLineJobDrawer's reads (finance-real, the user 2026-10-23): a job opened on any /finance tab (Jobs' rows, To do's
// rows), found in every client's jobs as the Jobs tab finds it; for its drawer its client's read (its quote) and the
// people who claim. A failed read of either is the drawer's to retry.
import type { UseQueryResult } from "@tanstack/react-query";
import { usePeople } from "../../hooks/useLedger";
import { useAgencyJobs, useClientJobs } from "../../hooks/useLineJobs";
import type { AgencyJobsResponse, AgencyLineJob, ClientJobsResponse, Person, QuoteBundle } from "../../types";

export interface AgencyLineJobDrawerModel {
  jobsQuery: UseQueryResult<AgencyJobsResponse>;
  /** Undefined while the list loads, or when it has no such job. */
  job: AgencyLineJob | undefined;
  /** Its client's read, for its quote: idle for a job on no quote. */
  clientQuery: UseQueryResult<ClientJobsResponse>;
  /** Its quote, from its client's read; undefined with none, or until that read answers. */
  quote: QuoteBundle | undefined;
  people: Person[];
}

export function useAgencyLineJobDrawer(jobId: string): AgencyLineJobDrawerModel {
  const jobsQuery = useAgencyJobs();
  const job = jobsQuery.data?.jobs.find((j) => j.id === jobId);
  const clientQuery = useClientJobs(job?.quoteId ? job.client.id : undefined);
  return { jobsQuery, job, clientQuery, quote: clientQuery.data?.quotes.find((q) => q.id === job?.quoteId), people: usePeople().data ?? [] };
}
